import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import env from '../../../../config/env';
import Button from '4all-ui/components/Button';
import ProductImage from '4all-ui/components/ProductImage';
import CloseIcon from '../../../Icons/Close';
import * as styles from './style';
import withCreateProductAddons from '../../../../containers/CreateProductsAddons';
import { getChildProductVariations } from '../../../../helpers/addons';

const showProductVariations = product => {
  const productVariations = getChildProductVariations(product);
  if (!productVariations.length) {
    return null;
  }

  return (
    <styles.VariationsContainer>
      <styles.VariationsList>
        {productVariations.map(variation => (
          <styles.Variation
            key={variation.id}
            id={`product-addon-option-${variation.id}`}
            className="option-name"
          >
            {variation.name}
          </styles.Variation>
        ))}
      </styles.VariationsList>
    </styles.VariationsContainer>
  );
};

const ProductAddonItem = ({ step, product, single, isLastProduct, removeStepAddonItem }) => {
  return (
    <Fragment>
      <styles.ItemContainer id={`product-item-${product.id}`}>
        <styles.LeftInfo>
          <styles.ImageContainer>
            <ProductImage
              size="50px"
              emptyText
              image={
                product.image.imageUrl ? `${env.REACT_APP_BASE_IMG}${product.image.imageUrl}` : null
              }
            />
            {single && showProductVariations(product)}
          </styles.ImageContainer>
          <styles.ProductName className="product-item-name">{product.name}</styles.ProductName>
        </styles.LeftInfo>
        <Button
          customStyles={{
            backgroundColor: 'transparent',
            border: 'none',
            minWidth: 'unset',
            padding: '0px',
            ':hover': {
              backgroundColor: 'transparent',
            },
          }}
          onClick={() => removeStepAddonItem(step.id, product.id)}
          id={`btn-remove-product-${product.id}`}
          className="btn-remove-product-item"
        >
          <CloseIcon size="20px" />
        </Button>
      </styles.ItemContainer>
      {!single && !isLastProduct && (
        <styles.LineSeparator className="or-logic-operator">
          <styles.LogicOperatorTip>OU</styles.LogicOperatorTip>
        </styles.LineSeparator>
      )}
    </Fragment>
  );
};

ProductAddonItem.propTypes = {
  step: PropTypes.object,
  product: PropTypes.object,
  single: PropTypes.bool,
  isLastProduct: PropTypes.bool,
  removeStepAddonItem: PropTypes.func.isRequired,
};

ProductAddonItem.defaultProps = {
  single: false,
  isLastProduct: false,
};

export default withCreateProductAddons(ProductAddonItem);



// WEBPACK FOOTER //
// ./src/components/ProductAddons/CustomSteps/ProductAddonItem/index.js